module.exports = __webpack_public_path__ + "media/images/logout-ba2b8989601841dbca952b8388f051b0.svg";